/**
 * 班课api
 * 班课相关界面api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import AccountSummaryVo from './AccountSummaryVo';
import IdNameVo from './IdNameVo';
import StatisticsItemVo from './StatisticsItemVo';




  /**
   * The ClazzCourseVo model module.
   * @module clazz_course/model/ClazzCourseVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>ClazzCourseVo</code>.
   * @alias module:clazz_course/model/ClazzCourseVo
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>ClazzCourseVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:clazz_course/model/ClazzCourseVo} obj Optional instance to populate.
   * @return {module:clazz_course/model/ClazzCourseVo} The populated <code>ClazzCourseVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'courseStandard')) {
        obj['courseStandard'] = IdNameVo.constructFromObject(data['courseStandard']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'teacher')) {
        obj['teacher'] = AccountSummaryVo.constructFromObject(data['teacher']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'dept')) {
        obj['dept'] = IdNameVo.constructFromObject(data['dept']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'orgList')) {
        obj['orgList'] = ApiClient.convertToType(data['orgList'], [IdNameVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'schoolTerm')) {
        obj['schoolTerm'] = IdNameVo.constructFromObject(data['schoolTerm']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'closure')) {
        obj['closure'] = ApiClient.convertToType(data['closure'], 'Boolean');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'closeTime')) {
        obj['closeTime'] = ApiClient.convertToType(data['closeTime'], 'Date');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'statistics')) {
        obj['statistics'] = ApiClient.convertToType(data['statistics'], [StatisticsItemVo]);
      }
    }
    return obj;
  }

  /**
   * 班课id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 班课名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 班课名称
   * @member {String} code
   */
  exports.prototype['code'] = undefined;
  /**
   * 课程标准
   * @member {module:clazz_course/model/IdNameVo} courseStandard
   */
  exports.prototype['courseStandard'] = undefined;
  /**
   * 班课老师
   * @member {module:clazz_course/model/AccountSummaryVo} teacher
   */
  exports.prototype['teacher'] = undefined;
  /**
   * 分院
   * @member {module:clazz_course/model/IdNameVo} dept
   */
  exports.prototype['dept'] = undefined;
  /**
   * 行政班列表
   * @member {Array.<module:clazz_course/model/IdNameVo>} orgList
   */
  exports.prototype['orgList'] = undefined;
  /**
   * 学期
   * @member {module:clazz_course/model/IdNameVo} schoolTerm
   */
  exports.prototype['schoolTerm'] = undefined;
  /**
   * 是否结束
   * @member {Boolean} closure
   */
  exports.prototype['closure'] = undefined;
  /**
   * 结束时间
   * @member {Date} closeTime
   */
  exports.prototype['closeTime'] = undefined;
  /**
   * @member {Array.<module:clazz_course/model/StatisticsItemVo>} statistics
   */
  exports.prototype['statistics'] = undefined;



  export default exports;
;


